import * as React from "react";
const SvgArrowLeftSlick = (props) => /* @__PURE__ */ React.createElement("svg", { width: 6, height: 11, viewBox: "0 0 6 11", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5 1L1 5.5L5 10", stroke: "#1F1D1D", strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgArrowLeftSlick;
